module.exports = __webpack_public_path__ + "static/img/8-2.3f39f951.jpg";